import {faMagnifyingGlass, faTrash, faCheck, faXmark, faQuestion} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useEffect, useState} from "react";
import {element, func} from "prop-types";
import useAuthz from "../../hooks/useAuthz";

// TODO: exporter l'énum pour quel soit utilisable partout dans l'appli
const StatusElemPatri = {
    VALID: "valid",
    INVALID: "invalid",
    UNKNOWN: "unknown"
};

const ElemPatriActionRenderer = (props) => {
    const [rowData, setRowData] = useState([]);
    const [authz, user, profil] = useAuthz();

    useEffect(() => {
        let dataId = props.data.id;
        let currentRowData = [];

        // trajetDescr
        // setTrajetDescr

        props.api.forEachNode(function (node) {
            currentRowData.push(node.data);
        });

        setRowData(currentRowData);
    }, []);

    const onStatusBtnClicked = (status) => {
        let trajetDescr = props.trajetDescr;
        trajetDescr[props.retour][props.index].elemPatri.map((elem, i) => {
            if (elem.id === props.data.id) {
                elem.status = status;
                props.data.status = status;
            }
        });

        props.setTrajetDescr(trajetDescr);
        setRowData(trajetDescr[props.retour][props.index].elemPatri);
        setTimeout(() => {
            props.api.redrawRows();
        }, 400);
    }

    const onDetailBtnClicked = () => {
        // TODO:
    }

    const onDeleteBtnClicked = (dataId) => {
        let trajetElemPatri = props.trajetDescr[props.retour][props.index].elemPatri;
        let rowToDelete = rowData.filter(function (row) {
            return row.id === dataId;
        });

        let filteredElemPatri = trajetElemPatri.filter(function (elem) {
            return elem.id !== dataId;
        });

        let trajetDescr = props.trajetDescr;
        trajetDescr[props.retour][props.index].elemPatri = filteredElemPatri;

        props.setTrajetDescr(trajetDescr)

        props.api.applyTransaction({remove: rowToDelete});
    }

    return (
        <div>
            {
                <div style={{display: 'flex'}}>
                    <div className='buttons-request-table buttons-request-table-disabled'
                         // style={{backgroundColor: '#0092C9'}}
                         style={{backgroundColor: '#a1a1a1'}}
                         onClick={onDetailBtnClicked}
                    >
                        <FontAwesomeIcon icon={faMagnifyingGlass} style={{color: '#ffffff', height: '13px'}}/>
                    </div>
                    <div className={profil.profil === 1 || profil.profil === 2 || profil.profil === 3 ? 'buttons-request-table' : 'buttons-request-table buttons-request-table-disabled'} style={{backgroundColor: '#0092C9'}} onClick={() => {
                        onDeleteBtnClicked(props.data.id)
                    }}>
                        <FontAwesomeIcon icon={faTrash} style={{color: '#ffffff', height: '13px'}}/>
                    </div>
                    <div className={profil.profil === 1 || profil.profil === 2 || profil.profil === 3  ? 'buttons-request-table' : 'buttons-request-table buttons-request-table-disabled'} style={ props.data.status === StatusElemPatri.VALID ? {backgroundColor: '#A5C946'} : {backgroundColor: '#a1a1a1'}} onClick={() => {
                        onStatusBtnClicked(StatusElemPatri.VALID)
                    }}>
                        <FontAwesomeIcon icon={faCheck} style={{color: '#ffffff', height: '13px'}}/>
                    </div>
                    <div className={profil.profil === 1 || profil.profil === 2 || profil.profil === 3  ? 'buttons-request-table' : 'buttons-request-table buttons-request-table-disabled'} style={props.data.status === StatusElemPatri.UNKNOWN ? {backgroundColor: '#F18D2D'} : {backgroundColor: '#a1a1a1'}} onClick={() => {
                        onStatusBtnClicked(StatusElemPatri.UNKNOWN)
                    }}>
                        <FontAwesomeIcon icon={faQuestion} style={{color: '#ffffff', height: '13px'}}/>
                    </div>
                    <div className={profil.profil === 1 || profil.profil === 2 || profil.profil === 3  ? 'buttons-request-table' : 'buttons-request-table buttons-request-table-disabled'} style={props.data.status === StatusElemPatri.INVALID ? {backgroundColor: '#E85454'} : {backgroundColor: '#a1a1a1'}} onClick={() => {
                        onStatusBtnClicked(StatusElemPatri.INVALID)
                    }}>
                        <FontAwesomeIcon icon={faXmark} style={{color: '#ffffff', height: '13px'}}/>
                    </div>
                </div>
            }
        </div>)

}

export default ElemPatriActionRenderer;
